import { useState, useContext } from "react";
import { useEffect } from "react"
import { redirect, useSearchParams } from 'react-router-dom';
import { PageContext } from "./PageContext";
import { Loader, LoaderType } from '@progress/kendo-react-indicators';
import { Dialog } from '@progress/kendo-react-dialogs';

import React from "react";
import { makeCreatopyProof } from "../services/apiService";

class VieeProofEBoundary extends React.Component<{children: React.ReactNode}>{
    constructor(props: {children: React.ReactNode}){
        super(props);
        this.state={hasError:false}
    }

    static getDerivedStateFromError(error: Error){
        return {hasError:true}
    }
    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        console.log(error);
        console.log(errorInfo.componentStack);
    }
    render(): React.ReactNode {
        return this.props.children;
    }
}
export default function MakeCpyProof (){

    const [msg, setMsg]=useState("Your proof is being prepared. Please standby.")
    const [SearchParams] = useSearchParams();
    const slug = SearchParams.get('a')||"";
    
    useEffect(()=>{
        console.log(slug);
        if (slug){
            makeCreatopyProof(slug).then(data=>{
                console.log(data);
                setMsg("Your proof is ready");
                window.location.replace("/?ad="+slug);
            });
        }
    },[])

    return(
        <Dialog>
            <div style={{  display:"flex", justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                <h5>{msg}</h5>
            </div>
            <div style={{  display:"flex", justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                <Loader size="large" type="converging-spinner"></Loader>
            </div>
        </Dialog>
    )
}